import { datadogLogs, Logger } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import pino from "pino";
import { getPublicRuntimeConfig, isDev, isServerSide } from "../config";

declare global {
  interface Window {
    DD_LOGS: typeof datadogLogs;
    DD_RUM: typeof datadogRum;
  }
}

let clientLogger: Logger | null = null;
const serverLogger = isServerSide ? createServerLogger() : null;

function createServerLogger() {
  return pino(
    isDev
      ? {
          level: getPublicRuntimeConfig().logLevel ?? "debug",
          transport: {
            pipeline: [
              {
                target: "pino-pretty",
              },
            ],
          },
        }
      : {
          level: getPublicRuntimeConfig().logLevel ?? "info",
        },
  );
}

function initClientLogger() {
  if (isServerSide) {
    return;
  }

  clientLogger = window.DD_LOGS?.logger;
}

initClientLogger();

function info(msg: string, ...args: any[]) {
  if (isServerSide) {
    serverLogger?.info({ args }, msg);
  } else {
    clientLogger?.info(msg, { args });
  }
}

function error(err: Error, ...args: any[]) {
  if (isServerSide) {
    serverLogger?.error({ args, error: err }, err.message);
  } else {
    clientLogger?.error(err.message, { args, error: err });
  }
}

function warn(err: Error, ...args: any[]) {
  if (isServerSide) {
    serverLogger?.warn({ args, error: err }, err.message);
  } else {
    clientLogger?.error(err.message, { args, error: err });
  }
}

function debug(msg: string, ...args: any[]) {
  if (isServerSide) {
    serverLogger?.debug({ args }, msg);
  } else {
    clientLogger?.debug(msg, { args });
  }
}

export default { info, error, warn, debug };
